

















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { depositLogService, partSalesService, storeService } from '@/shared';
import { PartSale, PartSaleDetail, PaymentModel } from '@/models/fixedops/partsales';
import { IFilter } from '@/models/fixedops/partsales';
import { IDialogOption } from '@/models/dialog';
import { NotificationType, PaymentTypeDialog } from '@/helper/enum';
import { Utils } from '@/helper/utils';
import { IPaymentDialog } from '@/models/paymentDialog';


@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    totalSalesTax: {
      get() {
        if (this.partSaleDetail && this.partSaleDetail.partsSalesJson) {
          const totalTax = Number(this.partSaleDetail.partsSalesJson.taxTotal);
          return isNaN(totalTax) ? '0.00' : totalTax.toFixed(2);
        }
      },
    },
    isPayDisabled() {
      if (this.partSaleDetail && this.partSaleDetail.displayDueAmount) {
        return isNaN(Number(this.partSaleDetail.displayDueAmount)) || Number(this.partSaleDetail.displayDueAmount) <= 0;
      }
      return false;
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
    VAlynkSimpleTable: () => import('@/components/custom-templates/v-alynk-simple-table.vue'),
  },
})

export default class QrPartSalePaymentPage extends Base {
  public partSalesItems: any[] = [];
  public searchKey: string = '';
  public storeId: any = "";
  public storeLoading: boolean = false;
  public loading: boolean = false;
  public paymentLoading: boolean = false;
  public partSaleItem: any = [];
  public payment: PaymentModel = {};
  public partSaleDetail: PartSaleDetail = new PartSaleDetail();
  public isShowBypassReasonField: boolean = false;
  public paymentDialog: boolean = false;
  public isSendPaymentReceipt: boolean = true;
  // public isBypassCreditCardFeeRole: boolean = false;
  public isOverrideCCFeeApplied: boolean = true;
  public isPartSaleQrCodePaymentEnabled: boolean = false;
  public bypassReason: string = "";
  public amountToBePaid: string = '0.00';
  public sumTotalLineAmnt: string = "";
  public loggedInUserId: string = "";
  public loggedInUserEmail: string = "";
  public stores: any[] = [];
  public partSaleInvoiceNumber: string = "";
  public paymentUrl: string = "";
  public title: string = "";
  public isPaymentProviderConfigured: boolean = false;
  public paymentProviderStatusMessage: string = "";
  public urlFeildId: string = "";
  public currentStoreName: string = "";
  public formData: IPaymentDialog = {
    id: 'qr-part-payment',
    url: window.location.href,
    amount: 0,
    customerEmail: null,
    recordIdentifier: 'PartSale',
    type: '0'
  };
  public isPrefilledFromQuery: boolean = false;
  public formSkeletonLoading: boolean = false;


  public showResetConfirm: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.confirmResetFromQuery();
    },
  };

  public async mounted() {
    await this.getStores();
  }

  public async search() {
    this.clearData();
    if (this.storeId == null || this.storeId == "") {
      this.showNotification(NotificationType.Error, "Store is required");
      return;
    }

    const qrConfigWarningMessage =
      "QR Code payment is not configured for this store. Please contact the administrator.";

    if (!this.isPartSaleQrCodePaymentEnabled) {
      this.showNotification(NotificationType.Warning, qrConfigWarningMessage);
      return;
    }

    if (!this.isOverrideCCFeeApplied && this.bypassReason == "") {
      this.showNotification(NotificationType.Warning, qrConfigWarningMessage);
      return;
    }

    if (this.loggedInUserEmail == "" || this.loggedInUserId == "") {
      this.showNotification(NotificationType.Warning, qrConfigWarningMessage);
      return;
    }
    await this.getPartSalesDetail();
  }

  public clearData(): void {
    this.partSaleItem = [];
    this.partSaleDetail = new PartSaleDetail();
  }

  public async onStoreChange(): Promise<void> {
    this.partSaleInvoiceNumber = "";
    this.getQrPaymentStoreConfig();
    this.clearData();
  }

  public async onInvoiceNumberChange(): Promise<void> {
    this.clearData();
  }

  public async confirmPayment() {
    this.paymentLoading = true;
    this.$emit('update:progress', this.paymentLoading);
    try {
      let amount = '0.00';
      this.payment.paymentType = PaymentTypeDialog.manual;
      this.payment.amountPaid = '';
      this.payment.paymentMode = 'full';

      if (this.validateForm()) {

        // get amountToBePaid
        //To Do future handling for partial case
        // if (this.payment.paymentMode === 'full') {
        //   amount = this.partSaleDetail.displayDueAmount;
        // } else if (this.payment.paymentMode === 'partial') {
        //   amount = this.payment.amountPaid;
        // } else {
        //   this.showAlert(
        //     false,
        //     this.$t('partSalesDetails.alertPleaseSelectOnePaymentType')
        //   );
        //   return;
        // }
        amount = this.partSaleDetail.displayDueAmount;

        if (Number(amount) < 0) {
          this.showAlert(false, 'Amount Should be greater than 0');
          return;
        }

        if (!amount && Number(amount) <= 0) {
          this.showAlert(
            false,
            this.$t('partSalesDetails.alertAmountShouldGreaterThanZeroAndValid')
          );
          return;
        }

        if (Number(amount) > Number(this.partSaleDetail.displayDueAmount)) {
          this.showAlert(
            false,
            this.$t('partSalesDetails.alertAmountShouldLessThanTotalDue')
          );
          return;
        }
        if (this.isShowBypassReasonField && this.bypassReason == "") {
          return;
        }

        if (this.loggedInUserEmail == "" || this.loggedInUserId == "") {
          return;
        }

        if (!this.isPartSaleQrCodePaymentEnabled) {
          this.showNotification(NotificationType.Error, "Part sale QR payment is not configured for this store.");
          return;
        }
        //To Do verify what if transaction faild need to check 
        // this.paymentAmountDialog.model = false;
        this.amountToBePaid = amount;
        // show modal popup
        switch (this.payment.paymentType) {
          case PaymentTypeDialog.manual:
            if (this.partSaleDetail.store.provider == 'Vantiv') {
              // this.manualPaymentPopup.model = true;
              await this.payManually();
              //To Do create a function for transaction 
            } else if (this.partSaleDetail.store.provider == 'Cenpos') {
              if (this.partSaleDetail.store.isCenposConfigured) {
                const validateMessage = this.validateCenpos();
                if (validateMessage == '') {
                  // this.paymentDialog = true;
                  //To Do create a function for transaction 
                  await this.submitQrCodePayment();
                  this.$root.$emit('validatePaymentProvider');

                } else {
                  const message =
                    'Can not Make the payment because, Customer' +
                    validateMessage +
                    ' are Empty.';
                  this.showAlert(false, message);
                }
              } else {
                this.showAlert(false, this.$t('stores.cenpos.alertCeponsConfig'));
              }
            } else {
              // this.paymentDialog = true;
              //To Do create a function for transaction 
              await this.submitQrCodePayment();
              this.$root.$emit('validatePaymentProvider');
            }
            break;
          default:
            break;
        }
        this.payment.paymentMode = '';
      }
    } catch {

    }
    finally {
      setTimeout(() => {
        this.paymentLoading = false;
      }, 9000);
      this.$emit('update:progress', this.paymentLoading);
    }
  }

  public async getPartSalesDetail(): Promise<void> {
    try {
      this.loading = true;
      this.formSkeletonLoading = true;
      this.$emit('update:progress', this.loading);
      const partSale = await partSalesService.getPartSalesDetailForQrPayment(
        this.partSaleInvoiceNumber, 1, 1, this.storeId
      );
      if (partSale && partSale.partsSalesJson) {
        this.partSaleItem = [
          {
            sortName: partSale.partsSalesJson.sortName,
            counterPersonId: partSale.partsSalesJson.counterPersonId,
            displayDueAmount: partSale.displayDueAmount
          }
        ];
      }
      this.partSaleDetail = partSale;
      // this.fileOnCardsList = partSale.cards;
      if (
        this.partSaleDetail.partsSalesJson &&
        (!this.partSaleDetail.partsSalesJson.details ||
          !this.partSaleDetail.partsSalesJson.details.length)
      ) {
        this.partSaleDetail.partsSalesJson.details = [];
      }

      if (this.partSaleDetail.partsSalesJson.customerKey == '0') {
        this.partSaleDetail.partsSalesJson.customerKey = '';
      }
      if (this.partSaleDetail.customer == undefined) {
        this.partSaleDetail.customer = {
          name: '',
          email: '',
          email2: '',
          callTo: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipCode: '',
          homePhone: '',
          cellPhone: '',
          businessPhone: '',
          customerKey: '',
        };
      }

      this.partSaleDetail.invoiceNumber = this.partSaleInvoiceNumber;
    }
    finally {
      this.loading = false;
      await this.getPaymentProviderDetails();
      this.formData = {
        // Required
        id: 'qr-part-payment',
        url: window.location.href,
        amount: Number(this.partSaleDetail.displayDueAmount),
        totalAmount: this.getTotalAmount(),
        recordKey: this.partSaleDetail.invoiceNumber,
        recordIdentifier: 'PartSale',
        type: '0',

        // Context
        tenantId: 1,
        enterpriseId: 1,
        storeId: this.storeId,

        // Customer
        customerKey: this.partSaleDetail.customer?.customerKey ?? '',
        address: this.partSaleDetail.customer?.address1 ?? '',
        city: this.partSaleDetail.customer?.city ?? '',
        state: this.partSaleDetail.customer?.state ?? '',
        zipcode: this.partSaleDetail.customer?.zipCode ?? '',
        phoneNumber: this.partSaleDetail.customer?.homePhone ?? '',
        customerEmail: this.partSaleDetail.customer?.email ?? '',
        merchantEmail: this.partSaleDetail.customer?.email2 ?? '',

        // Flags
        isSendPaymentReceipt: this.isSendPaymentReceipt,
        isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
        bypassReason: this.bypassReason ?? '',

        // Optional / safe defaults
        dealId: 0,
        comments: '',
        other: '',
        lineItems: '',
        ArPayments: '',
      };
      this.formSkeletonLoading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public async payManually(): Promise<void> {
    if (Number(this.amountToBePaid) < 0) {
      this.showAlert(false, 'Amount Should be greater than 0');
      return;
    }

    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('partSalesDetails.alertTotalAmountIsZero'));
      return;
    }

    // copy amountToBePaid to displayDue
    const amount = this.partSaleDetail.displayDueAmount;
    const totalAmount = this.sumTotalAmount();
    try {
      this.partSaleDetail.displayDueAmount = this.amountToBePaid;
      const response = await partSalesService.partSalesQrPayment(
        this.partSaleDetail,
        totalAmount,
        1,
        1,
        this.storeId
      );
      location.href = response.redirectUri;
    } catch (e) {
      this.partSaleDetail.displayDueAmount = amount;
    } finally {
    }
  }

  public sumTotalAmount(): string {
    const shipping = isNaN(
      Number(this.partSaleDetail.partsSalesJson.shippingTotal)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.shippingTotal);
    const tax = isNaN(Number(this.partSaleDetail.partsSalesJson.taxTotal))
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.taxTotal);
    const specialOrderDeposit = isNaN(
      Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit);
    const total =
      Number(this.partSaleDetail.partsSalesJson.partsTotal) +
      shipping +
      tax +
      specialOrderDeposit;
    return total.toFixed(2);
  }

  public sumTotalAmountWithoutParts() {
    const shipping = isNaN(
      Number(this.partSaleDetail.partsSalesJson.shippingTotal)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.shippingTotal);
    const tax = isNaN(Number(this.partSaleDetail.partsSalesJson.taxTotal))
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.taxTotal);
    const specialOrderDeposit = isNaN(
      Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit);

    const partTotal = isNaN(
      Number(this.partSaleDetail.partsSalesJson.partsTotal)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.partsTotal);

    const total = partTotal + shipping + tax + specialOrderDeposit;
    return total;
  }

  public validateCenpos(): string {
    let message = '';
    if (
      this.partSaleDetail.customer.city == undefined ||
      this.partSaleDetail.customer.city == ''
    ) {
      message += ' City';
    }

    if (
      (this.partSaleDetail.customer &&
        this.partSaleDetail.customer.customerKey == undefined) ||
      this.partSaleDetail.customer.customerKey == ''
    ) {
      message += ' CustomerKey';
    }

    if (
      this.partSaleDetail.customer.state == undefined ||
      this.partSaleDetail.customer.state == ''
    ) {
      message += ' State';
    }

    if (
      this.partSaleDetail.customer.address1 == undefined &&
      this.partSaleDetail.customer.address1 == ''
    ) {
      message += ' Address';
    }

    return message;
  }

  public async getStores(): Promise<void> {
    try {
      this.storeLoading = true;
      const response = await storeService.getStoresForQrPayment(1, 1, 1);
      this.stores = response.results;
      await this.applyQueryParams();

    } catch (ex) {
      console.log(ex);

    } finally {
      this.storeLoading = false;
    }
  }

  public getQrPaymentStoreConfig(): void {
    try {
      this.storeLoading = true;
      const store = this.stores.find(x => x.id === this.storeId);

      if (!store) {
        console.warn("QR Payment store configuration not found for storeId:", this.storeId);
        return;
      }

      this.isOverrideCCFeeApplied = store.isOverrideCCFeeApplied ?? false;
      this.bypassReason = store.bypassReason ?? "";
      this.isShowBypassReasonField = !this.isOverrideCCFeeApplied;
      this.loggedInUserEmail = store.loggedInUserEmail ?? "";
      this.loggedInUserId = store.loggedInUserId ?? "";
      this.isPartSaleQrCodePaymentEnabled = store.isPartSaleQrCodePaymentEnabled ?? false;

    } catch (ex) {
      console.error("Error while loading QR Payment store config", ex);
    } finally {
      this.storeLoading = false;
    }
  }

  public async getPaymentProviderDetails() {
    this.loading = true;
    this.formSkeletonLoading = true;
    try {
      const result = await depositLogService.getDefaultPaymentProvider(
        this.storeId
      );
      this.currentStoreName = result.storeName;
      this.paymentUrl = Utils.WEB_BASE_URL;
      if (result.paymentProvider == "Clover") {

        if (result.isCloverConfigured) {
          this.paymentUrl += '/serverpay/clover';
          this.title = "Clover Web Pay";
          this.isPaymentProviderConfigured = true;
        }
        else {
          this.paymentProviderStatusMessage = 'Clover Payment not configured, please contact admin';

        }
      } else if (result.paymentProvider == "Cenpos") {

        if (result.isCenposConfigured) {
          this.paymentUrl += '/serverpay/cenpos';
          this.title = "Cenpos Web Pay";
          this.isPaymentProviderConfigured = true;
        }
        else {
          this.paymentProviderStatusMessage = 'Cenpos Payment not configured, please contact admin';

        }

      } else if (result.paymentProvider == "Square") {

        if (result.isSquareConfigured) {
          this.paymentUrl += '/serverpay/square';
          this.title = "Square Web Pay";
          this.isPaymentProviderConfigured = true;
        }
        else {
          this.paymentProviderStatusMessage = 'Square Payment not configured, please contact admin';

        }

      } else if (result.paymentProvider == "Payroc") {

        if (result.isPayrocConfigured) {
          this.paymentUrl += '/serverpay/payroc';
          this.title = "Payroc Web Pay";
          this.isPaymentProviderConfigured = true;
        }
        else {
          this.paymentProviderStatusMessage = 'Payroc Payment not configured, please contact admin';
        }
      }
      else if (result.paymentProvider == "AuthorizeNet") {
        if (result.isAuthorizeNetConfigured) {
          this.paymentUrl += '/serverpay/authorizeNet';
          this.title = "AuthorizeNet Web Pay";
          this.isPaymentProviderConfigured = true;
        }
        else {
          this.paymentProviderStatusMessage = 'AuthorizeNet Payment not configured, please contact admin';
        }
      }
      else if (result.paymentProvider == "Redrock") {
        if (result.isRedrockConfigured) {
          this.paymentUrl += '/serverpay/redrock';
          this.title = "Redrock Web Pay";
          this.isPaymentProviderConfigured = true;
        }
        else {
          this.paymentProviderStatusMessage = 'Redrock Payment not configured, please contact admin';
        }
      }
    } finally {
      this.loading = false;
      this.formSkeletonLoading = false;
    }
  }
  public getTotalAmount() {
    let totalAmount = 0;
    totalAmount = this.sumTotalAmountWithoutParts();
    return totalAmount.toFixed(2);
  }
  public async submitQrCodePayment(): Promise<void> {

    if (!this.isPaymentProviderConfigured) {
      if (this.paymentProviderStatusMessage) {
        this.showAlert(false, this.paymentProviderStatusMessage);
        return;
      }
    }
    const form = this.$refs.qrCodePaymentForm as HTMLFormElement;
    form.submit();
  }

  private async applyQueryParams(): Promise<void> {
    const { storeId, invoiceNumber } = this.$route.query;

    if (storeId || invoiceNumber) {
      this.isPrefilledFromQuery = true; // 🔒 lock UI
    }

    let shouldSearch = false;

    // ----- STORE -----
    if (storeId) {
      // ensure store exists in dropdown
      const storeExists = this.stores.some(s => s.id === storeId);

      if (storeExists) {
        this.storeId = storeId;

        // trigger existing logic
        await this.onStoreChange();

        shouldSearch = true;
      } else {
        console.warn('StoreId not found in store list:', storeId);
      }
    }

    // ----- INVOICE -----
    if (invoiceNumber) {
      this.partSaleInvoiceNumber = invoiceNumber.toString();
      shouldSearch = true;
    }

    // ----- AUTO SEARCH -----
    if (shouldSearch) {
      await this.$nextTick();
      await this.search();
    }
  }

  public resetFromQuery(): void {
    // 1️⃣ Remove query params from URL
    this.$router.replace({ query: {} });

    // 2️⃣ Unlock UI
    this.isPrefilledFromQuery = false;

    // 3️⃣ Reset form fields
    this.storeId = null;
    this.partSaleInvoiceNumber = '';

    // 4️⃣ Reset data
    this.clearData();

    // 5️⃣ Reset QR-specific flags safely
    this.isPartSaleQrCodePaymentEnabled = false;
    this.isShowBypassReasonField = false;
    this.bypassReason = '';
  }

  public confirmResetFromQuery(): void {
    this.showResetConfirm.model = false;
    this.resetFromQuery();
  }

  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('partSales.partSalesGrid.sortName') as string,
      value: 'sortName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('partSales.partSalesGrid.counterPerson') as string,
      value: `counterPersonId`,
    },
    {
      align: 'left',
      sortable: true,
      text: "Payable Amount",
      value: `displayDueAmount`,
    }
  ];

}
